/**
 * ThemeToggle — a small button that flips between light and dark.
 *
 * Shows a sun icon in dark mode (click to go light) and a moon in light mode.
 * Long-press or right-click could add a menu with an explicit "System" option,
 * but the primary tap-target is the simple flip since that's what 95% of
 * users want.
 */
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export default function ThemeToggle({ variant = "ghost" }) {
  const { resolvedTheme, toggle } = useTheme();
  const isLight = resolvedTheme === "light";
  const cls =
    variant === "ghost"
      ? "ld-btn ld-btn-ghost !p-2"
      : "ld-btn ld-btn-primary !p-2";
  return (
    <button
      onClick={toggle}
      className={cls}
      title={isLight ? "Switch to dark mode" : "Switch to light mode"}
      aria-label={isLight ? "Switch to dark mode" : "Switch to light mode"}
      data-testid="theme-toggle"
    >
      {isLight ? <Moon size={15} strokeWidth={1.75} /> : <Sun size={15} strokeWidth={1.75} />}
    </button>
  );
}
